export default {
    bold:                'bold',
    small:               'small',
    standard:            'standard',
    standardSmallMargin: 'standardSmallMargin',
};
